import { defineComponent as n, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as a, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "7ed41d77-873f-41c9-8c3d-99bd564857c1" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#7ed41d77-873f-41c9-8c3d-99bd564857c1)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 160 256-32 256 32v192l-256 32L0 352Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 0h512v160H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 352h512v160H0Z"
}, null, -1), x = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "64",
  fill: "#ffda44"
}, null, -1), w = { fill: "none" }, y = ["r"], C = /* @__PURE__ */ n({
  __name: "ru-ba",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), d = o(() => 256 + t.strokeWidth / 2);
    return (W, B) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", k, a(t.flagName), 1)) : _("", !0),
        p,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  C as default
};
//# sourceMappingURL=ru-ba-019eb428.js.map
